import { useQueryUserBillingInfo } from '../../data/query/useQueryUserBillingInfo';
import { isMaxBillingSeat } from './is-max-billing-seat';

/** True when billing reports a Max seat on any tier (Clinician Max or Practice Max). */
export function useIsMaxBillingSeat(): boolean {
  const { data: billingInfo } = useQueryUserBillingInfo();
  return isMaxBillingSeat(billingInfo);
}
